import { AlertState } from '@/model/AlertState'

export const alert = {
  namespaced: true,
  state: {
    type: null,
    message: null,
    showMessage: false,
  },
  actions: {
    success({ commit }: Record<any, any>, message: string) {
      commit('success', message)
    },
    error({ commit }: Record<any, any>, message: string) {
      commit('error', message)
    },
    warning({ commit }: Record<any, any>, message: string) {
      commit('warning', message)
    },
    info({ commit }: Record<any, any>, message: string) {
      commit('info', message)
    },
    clear({ commit }: Record<any, any>) {
      commit('clear')
    },
  },
  mutations: {
    success(state: AlertState, message: string) {
      state.type = 'success'
      state.showMessage = true
      state.message = message
    },
    error(state: AlertState, message: string) {
      state.type = 'error'
      state.showMessage = true
      state.message = message
    },
    warning(state: AlertState, message: string) {
      state.type = 'warning'
      state.showMessage = true
      state.message = message
    },
    info(state: AlertState, message: string) {
      state.type = 'info'
      state.showMessage = true
      state.message = message
    },
    clear(state: AlertState) {
      state.type = null
      state.showMessage = false
      state.message = null
    },
  },
}
